import * as ModulesConfig from '@/configs/ModulesConfig';

export const getModuleById = (targetId) => {
    const foundModule = Object.values(ModulesConfig).find(
        (exportedItem) => exportedItem?.id === targetId
    );

    return foundModule || null;
};